import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { X, Plus, Minus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { jmd } from "@/lib/format";

export function CartDrawer() {
  const { items, drawerOpen, setDrawerOpen, setQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();
  if (!drawerOpen) return null;
  return (
    <div className="fixed inset-0 z-[70]">
      <div className="absolute inset-0 bg-black/50" onClick={() => setDrawerOpen(false)} />
      <div className="absolute right-0 top-0 bottom-0 w-[420px] max-w-[92%] bg-white flex flex-col sn-fade-up" data-testid="cart-drawer">
        <div className="flex items-center justify-between p-5 border-b border-border">
          <h3 className="font-display text-lg font-bold flex items-center gap-2"><ShoppingBag size={20} /> Your Cart</h3>
          <button onClick={() => setDrawerOpen(false)}><X /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 grid place-items-center text-center p-8">
            <div>
              <ShoppingBag size={44} className="mx-auto text-slate-300 mb-3" />
              <p className="text-muted-foreground">Your cart is empty.</p>
              <button onClick={() => { setDrawerOpen(false); navigate("/"); }} className="mt-4 text-emerald font-semibold">Start shopping →</button>
            </div>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              {items.map((i) => (
                <div key={i.product_id} className="flex gap-3">
                  <img src={i.image} alt={i.name} className="h-20 w-20 rounded-lg object-cover bg-slate-100" />
                  <div className="flex-1 min-w-0">
                    <Link to={`/product/${i.product_id}`} onClick={() => setDrawerOpen(false)} className="font-medium text-sm line-clamp-2 hover:text-emerald">{i.name}</Link>
                    <div className="font-display font-bold mt-1">{jmd(i.price)}</div>
                    <div className="flex items-center gap-2 mt-2">
                      <div className="flex items-center border border-border rounded-lg">
                        <button onClick={() => setQty(i.product_id, i.quantity - 1)} className="p-1.5"><Minus size={14} /></button>
                        <span className="w-8 text-center text-sm font-semibold">{i.quantity}</span>
                        <button onClick={() => setQty(i.product_id, i.quantity + 1)} className="p-1.5"><Plus size={14} /></button>
                      </div>
                      <button onClick={() => removeItem(i.product_id)} className="text-coral p-1.5"><Trash2 size={16} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-border p-5 space-y-3">
              <div className="flex justify-between font-display"><span className="text-muted-foreground">Subtotal</span><span className="font-bold text-lg">{jmd(subtotal)}</span></div>
              <button data-testid="drawer-checkout-btn" onClick={() => { setDrawerOpen(false); navigate("/checkout"); }}
                className="w-full bg-ink text-white rounded-xl py-3 font-semibold hover:bg-emerald-deep transition-colors">
                Checkout · {jmd(subtotal)}
              </button>
              <button onClick={() => { setDrawerOpen(false); navigate("/cart"); }} className="w-full text-sm text-muted-foreground hover:text-ink">View full cart</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
